function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".Home_icon_svg__cls-2{fill:#fff}"));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Home_icon_svg__Warstwa_2",
  "data-name": "Warstwa 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Home_icon_svg___3",
  "data-name": 3
}, /*#__PURE__*/React.createElement("circle", {
  cx: 23.5,
  cy: 23.5,
  r: 23.5,
  fill: "#21374d"
}), /*#__PURE__*/React.createElement("path", {
  className: "Home_icon_svg__cls-2",
  d: "M33.49 25l-9.56-8.44a.65.65 0 00-.87 0L13.51 25a.33.33 0 00-.11.25v9.93a.33.33 0 00.33.33h6.72a.33.33 0 00.33-.33v-6.35a1.31 1.31 0 011.31-1.31h2.84a1.31 1.31 0 011.31 1.31v6.34a.33.33 0 00.33.33h6.72a.33.33 0 00.33-.33v-9.92a.33.33 0 00-.13-.25z"
}), /*#__PURE__*/React.createElement("path", {
  className: "Home_icon_svg__cls-2",
  d: "M36.12 21.72l-10.89-9.57a2.62 2.62 0 00-3.46 0l-10.89 9.57a1.24 1.24 0 00-.06 1.8 1.24 1.24 0 001.69.05l10.12-8.91a1.31 1.31 0 011.73 0l10.12 8.91a1.24 1.24 0 101.63-1.86z"
})));

function SvgHomeicon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 47 47"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0NyA0NyI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOiMyMTM3NGQ7fS5jbHMtMntmaWxsOiNmZmY7fTwvc3R5bGU+PC9kZWZzPjx0aXRsZT5aYXPDs2IgMzwvdGl0bGU+PGcgaWQ9IldhcnN0d2FfMiIgZGF0YS1uYW1lPSJXYXJzdHdhIDIiPjxnIGlkPSJfMyIgZGF0YS1uYW1lPSIzIj48Y2lyY2xlIGNsYXNzPSJjbHMtMSIgY3g9IjIzLjUiIGN5PSIyMy41IiByPSIyMy41Ii8+PHBhdGggY2xhc3M9ImNscy0yIiBkPSJNMzMuNDksMjVsLTkuNTYtOC40NGEuNjUuNjUsMCwwLDAtLjg3LDBMMTMuNTEsMjVhLjMzLjMzLDAsMCwwLS4xMS4yNXY5LjkzYS4zMy4zMywwLDAsMCwuMzMuMzNoNi43MmEuMzMuMzMsMCwwLDAsLjMzLS4zM1YyOC44M2ExLjMxLDEuMzEsMCwwLDEsMS4zMS0xLjMxaDIuODRhMS4zMSwxLjMxLDAsMCwxLDEuMzEsMS4zMXY2LjM0YS4zMy4zMywwLDAsMCwuMzMuMzNoNi43MmEuMzMuMzMsMCwwLDAsLjMzLS4zM1YyNS4yNUEuMzMuMzMsMCwwLDAsMzMuNDksMjVaIi8+PHBhdGggY2xhc3M9ImNscy0yIiBkPSJNMzYuMTIsMjEuNzIsMjUuMjMsMTIuMTVhMi42MiwyLjYyLDAsMCwwLTMuNDYsMEwxMC44OCwyMS43MmExLjI0LDEuMjQsMCwwLDAtLjA2LDEuOGgwYTEuMjQsMS4yNCwwLDAsMCwxLjY5LjA1bDEwLjEyLTguOTFhMS4zMSwxLjMxLDAsMCwxLDEuNzMsMGwxMC4xMiw4LjkxYTEuMjQsMS4yNCwwLDEsMCwxLjYzLTEuODZaIi8+PC9nPjwvZz48L3N2Zz4=";
export { SvgHomeicon as ReactComponent };